interface LogoProps {
  size?: 'small' | 'normal';
}

export default function Logo({ size = 'normal' }: LogoProps) {
  const dimensions = size === 'small' ? 'w-8 h-8' : 'w-16 h-16';

  return (
    <div className={`${dimensions} rounded-full bg-wobisch-blue flex items-center justify-center`}>
      <svg
        viewBox="0 0 100 100"
        className="w-3/4 h-3/4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="35" r="15" fill="white" />
        <path
          d="M50 55 L50 85 M35 65 L50 55 L65 65"
          stroke="white"
          strokeWidth="8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
